import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavAssets = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path fill="#88827E" d="M4 5h6l2 2h8v12H2v2h20V5h-9l-2-2H2v14h2V5Z" />
    <path fill="#88827E" d="m13 7-6 7h4v5l6-7h-4V7Z" />
  </svg>
);
export default SvgNavAssets;
